let config = null;
export async function loadConfig() {
    if (config) {
        return config;
    }
    try {
        const response = await fetch('/config.json');
        if (!response.ok) {
            throw new Error(`Failed to load config: ${response.statusText}`);
        }
        config = await response.json();
        return config;
    }
    catch (error) {
        console.error('Failed to load config.json, falling back to env variables', error);
        // Fallback to build-time environment variables
        config = {
            REACT_APP_API_URL: process.env.REACT_APP_API_URL || '',
            REACT_APP_AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN || '',
            REACT_APP_AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
            REACT_APP_AUTH0_NAMESPACE: process.env.REACT_APP_AUTH0_NAMESPACE || '',
            REACT_APP_AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE || '',
        };
        return config;
    }
}
export function getConfig() {
    if (!config) {
        throw new Error('Config not loaded. Call loadConfig() first.');
    }
    return config;
}
/* for tests */
export function resetConfig() {
    config = null;
}
